import { render, staticRenderFns } from "./points.vue?vue&type=template&id=55e369f9&scoped=true&"
import script from "./points.vue?vue&type=script&lang=js&"
export * from "./points.vue?vue&type=script&lang=js&"
import style0 from "./points.vue?vue&type=style&index=0&id=55e369f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e369f9",
  null
  
)

export default component.exports